// Global fetch interceptor:
// 1) Backend'e giden TÜM isteklere credentials: "include" ekler (httpOnly token
//    cookie'sinin gönderilmesi için) ve localStorage'daki token'ı Authorization
//    header'ı olarak iletir (cookie gönderilemeyen durumlar için yedek).
// 2) Oturum gerektiren bir istek 401/403 dönerse local oturumu temizleyip
//    kullanıcıyı login ekranına yönlendirir.
// Bu dosya index.js'te diğer her şeyden ÖNCE import edilmelidir.

const API_HOSTS = [
  "localhost:5001",
  "127.0.0.1:5001",
  "app.vivasmartcare.com/api",
  process.env.REACT_APP_API_URL,
]
  .filter(Boolean)
  .map((h) => h.replace(/^https?:\/\//, "").replace(/\/$/, ""));

// 401 dönmesi "oturum düştü" anlamına gelmeyen endpoint'ler
const AUTH_EXEMPT_PATHS = ["/logins", "/logout", "/profile/"];

// Yalnızca admin'e açık uçlar: 403 "yetkin yok" demektir, oturum düşmemiştir.
// Bu uçlarda 403'te login'e yönlendirme yapılmaz, sayfa kendi mesajını gösterir.
const ADMIN_ONLY_PATHS = ["/admin/"];

const originalFetch = window.fetch.bind(window);

window.fetch = async (input, init = {}) => {
  const url = typeof input === "string" ? input : input?.url || "";
  const isApiRequest = API_HOSTS.some((host) => url.includes(host));

  if (isApiRequest) {
    const headers = new Headers(init.headers || {});
    const token = localStorage.getItem("token");
    if (token && !headers.has("Authorization")) {
      headers.set("Authorization", `Bearer ${token}`);
    }
    init = { ...init, credentials: "include", headers };
  }

  const response = await originalFetch(input, init);

  const isAdminOnly = ADMIN_ONLY_PATHS.some((path) => url.includes(path));
  const sessionLost =
    response.status === 401 || (response.status === 403 && !isAdminOnly);

  if (
    isApiRequest &&
    sessionLost &&
    !AUTH_EXEMPT_PATHS.some((path) => url.includes(path)) &&
    window.location.pathname !== "/login"
  ) {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    window.location.href = "/login";
  }

  return response;
};
